import { useState } from 'react'
import { ClinicCreationForm } from '@/components/clinic/ClinicCreationForm'
import { useClinics } from '@/hooks/useClinics'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Building2 } from 'lucide-react'

export function ClinicManagementPage() {
  const { useMyClinics } = useClinics()
  const { data: clinics, isLoading } = useMyClinics()
  const [showCreateForm, setShowCreateForm] = useState(false)

  if (isLoading) {
    return <div className="p-8 text-center">Cargando clínicas...</div>
  }

  return (
    <div className="container mx-auto p-6 space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold tracking-tight">Gestión de clínicas</h1>
      </div>

      {!clinics || clinics.length === 0 ? (
        <div className="flex flex-col items-center justify-center p-12 border-2 border-dashed rounded-lg space-y-4">
          <Building2 className="w-12 h-12 text-muted-foreground" />
          <h2 className="text-xl font-semibold">Aún no tienes clínicas</h2>
          <p className="text-muted-foreground text-center max-w-md">
            No perteneces a ninguna clínica. Crea una nueva clínica para comenzar.
          </p>
          <div className="w-full max-w-md mt-6">
            <ClinicCreationForm onSuccess={() => setShowCreateForm(false)} />
          </div>
        </div>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {clinics.map((clinic) => (
            <Card key={clinic.id}>
              <CardHeader>
                <CardTitle className="flex justify-between items-start">
                  <span>{clinic.name}</span>
                  {clinic.is_owner && <Badge variant="default">Propietario</Badge>}
                </CardTitle>
                <CardDescription>
                  Rol: {clinic.role_name || 'Miembro'}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Estado:</span>
                    <Badge variant={clinic.is_active ? 'secondary' : 'destructive'}>
                      {clinic.is_active ? 'Activa' : 'Inactiva'}
                    </Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
          
          <Card className="flex flex-col items-center justify-center p-6 border-dashed cursor-pointer hover:bg-muted/50 transition-colors" onClick={() => setShowCreateForm(!showCreateForm)}>
            <Building2 className="w-8 h-8 mb-2 text-muted-foreground" />
            <span className="font-medium text-muted-foreground">Agregar clínica</span>
          </Card>
        </div>
      )}

      {showCreateForm && clinics && clinics.length > 0 && (
        <div className="mt-8 border-t pt-8">
          <ClinicCreationForm onSuccess={() => setShowCreateForm(false)} />
        </div>
      )}
    </div>
  )
}
